import React from 'react';

export const RocketIcon = () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.71.79-1.81.19-2.58l-.61-.61c-.77-.6-1.87-.52-2.58.19z" />
        <path d="m9 15 3-3" />
        <path d="M17 11l.28-.28a1 1 0 0 0 0-1.42l-3.58-3.58a1 1 0 0 0-1.42 0L12 6" />
        <path d="M21 3.01s-9 0-13 8c0 0 0 0 0 0l-1.22 1.22a1 1 0 0 0 0 1.41l2.59 2.59a1 1 0 0 0 1.41 0L12 15c8-4 8-13 8-13" />
    </svg>
);

export const ToolsIcon = () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a2 2 0 0 1-2.52-2.52L14.7 6.3Z" />
        <path d="m3 21 6-6" />
        <path d="M9 15c.5.5 1.3.5 1.8 0l2.5-2.5c.5-.5.5-1.3 0-1.8l-1.6-1.6c-.5-.5-1.3-.5-1.8 0l-2.5 2.5c-.5.5-.5 1.3 0 1.8l1.6 1.6Z" />
        <path d="M21 21s-2-3-5-3-5 3-5 3" />
    </svg>
);

export const SearchIcon = () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.3-4.3" />
        <path d="M11 8a3 3 0 0 0-3 3" />
    </svg>
);

export const TelegramIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.665 3.717l-17.73 6.837c-1.21.486-1.203 1.161-.222 1.462l4.552 1.42l10.532-6.645c.498-.303.953-.14.579.192l-8.533 7.701l-.33 4.955c.488 0 .705-.223.978-.488l2.35-2.285l4.888 3.61c.902.497 1.55.241 1.775-.838l3.205-15.101c.33-1.32-.505-1.92-1.473-1.52z" fill="currentColor"/>
    </svg>
);

export const EmailIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M22 6l-10 7L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

export const PhoneIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.81 12.81 0 0 0 .62 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.62A2 2 0 0 1 22 16.92z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);